import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-5\" id=\"sizes\"><a href=\"#sizes\"></a> Sizes </h1><div class=\"py-5\"> Assign responsive-friendly size to a symbol element with shorthand classes. The classes are named using the format <code>.symbol-{size}</code> for <code>xs</code> and <code>.symbol-{breakpoint}-{size}</code> for <code>sm</code>, <code>md</code>, <code>lg</code>, <code>xl</code>, and <code>xxl</code>. </div>", 2)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Where ")
const _hoisted_6 = /*#__PURE__*/_createVNode("code", null, "size", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" is one of: ")
const _hoisted_8 = { class: "pt-3" }
const _hoisted_9 = { class: "py-5" }
const _hoisted_10 = { class: "rounded border p-10 pb-0 d-flex flex-wrap align-items-center" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "symbol-label fs-2 fw-bold text-success" }, "A", -1)
const _hoisted_12 = { class: "py-5" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
        <div class="symbol symbol-30px">
          <div class="symbol-label fs-2 fw-bold text-success">A</div>
        </div>
        <div class="symbol symbol-50px">
          <div class="symbol-label fs-2 fw-bold text-success">A</div>
        </div>
        <div class="symbol symbol-75px">
          <div class="symbol-label fs-2 fw-bold text-success">A</div>
        </div>
        <div class="symbol symbol-100px">
          <div class="symbol-label fs-2 fw-bold text-success">A</div>
        </div>
        <div class="symbol symbol-125px">
          <div class="symbol-label fs-2 fw-bold text-success">A</div>
        </div>
        <div class="symbol symbol-150px">
          <div class="symbol-label fs-2 fw-bold text-success">A</div>
        </div>
        `))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _createVNode("ul", _hoisted_8, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.symbolSizes, (item, i) => {
          return (_openBlock(), _createBlock("li", {
            key: i,
            class: "py-2"
          }, [
            _createVNode("code", null, _toDisplayString(item), 1),
            _createTextVNode(" - for classes that set height and width to " + _toDisplayString(item), 1)
          ]))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("div", _hoisted_10, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sizes, (item, i) => {
          return (_openBlock(), _createBlock("div", {
            key: i,
            class: [`symbol-${item}`, "symbol me-10 mb-10"]
          }, [
            _hoisted_11
          ], 2))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _hoisted_13
        ]),
        _: 1
      })
    ])
  ]))
}